import { render, staticRenderFns } from "./DepartmentSelectbox.vue?vue&type=template&id=62b40f94"
import script from "./DepartmentSelectbox.vue?vue&type=script&lang=js"
export * from "./DepartmentSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports